module.exports = __webpack_public_path__ + "img/machine-code-guide2.1e0527ef.png";